import { render } from "./Spindles.vue?vue&type=template&id=a8fc789c&scoped=true"
import script from "./Spindles.vue?vue&type=script&lang=js"
export * from "./Spindles.vue?vue&type=script&lang=js"

import "./Spindles.vue?vue&type=style&index=0&id=a8fc789c&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8fc789c"]])

export default __exports__